<div class="chat-bot">
  <div
    id="quickviewDefault"
    class="quickview"
    [ngClass]="{ 'is-active': toggleBotChat }"
  >
    <div class="quickview-header">
      <p class="title">Chat bot</p>
      <span class="delete" (click)="toggleQuickView()"></span>
    </div>

    <div class="quickview-body" #botChatArea>
      @for (content of messageContent.output; track content) {
      <div class="quickview-block">
        @if (content.sender === 'bot') {
        <div class="">
          @for (msg of content.message; track msg) {
          <div class="columns">
            <div class="column">
              <div class="is-pulled-left">
                <div class="talk-bubble tri-right left-top">
                  <div class="talktext">
                    <span>
                      <strong>Canny</strong>
                    </span>
                    <p>{{ msg }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        } @if (content.sender === 'me') {
        <div class="">
          @for (msg of content.message; track msg) {
          <div class="columns">
            <div class="column">
              <div class="is-pulled-right">
                <div class="talk-bubble tri-right round right-in">
                  <div class="talktext">
                    <span>
                      <strong>Me</strong>
                    </span>
                    <p>{{ msg }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
    </div>

    <footer class="quickview-footer">
      <input
        class="input"
        type="text"
        [(ngModel)]="newBotMessage"
        placeholder="Type here..."
        (keyup.enter)="postBotMessage(newBotMessage)"
      />
    </footer>
  </div>
  <!-- <div class="chat-bot-btn" *ngIf="!toggleBotChat">
  <button class="button is-link" (click)="toggleQuickView()">
    <i class="fa fa-comment" aria-hidden="true"></i>
  </button>
</div> -->
</div>
